import { useEffect } from 'react';

import { useCard } from 'src/components/Router/useCard';
import { useEnterReadMode } from 'src/components/Router/useEnterReadMode';
import { useMode } from 'src/components/Router/useMode';
import { useNavigateRoute } from 'src/components/Router/useNavigateRoute';
import { EDIT } from 'src/consts';

export const useWindowHistory = () => {
  const navigate = useNavigateRoute();
  const card = useCard();
  const mode = useMode(card);
  const enterReadMode = useEnterReadMode();

  useEffect(() => {
    const windowHistoryListener = () => {
      if (mode === EDIT && card) {
        enterReadMode();
      }
    };

    window.addEventListener('popstate', windowHistoryListener);

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    const cleanupListener = () => {
      window.removeEventListener('popstate', windowHistoryListener);
    };

    return cleanupListener;
  }, [navigate, card, mode, enterReadMode]);
};
